module.exports = __webpack_public_path__ + "static/torpor.0e182cc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/examples/vampire-example/torpor.png
// module id = 1016
// module chunks = 13396140415750